import PropTypes from 'prop-types'
import React from 'react'
import QuestionComponentMounter from '../question_types_admin/QuestionComponentMounter'
import clsx from 'clsx'

export const AnswerLinesChildrenGroup = ({ answerLine, dispatch = 'Answer', subChildrenClassName }) => {
  const answersByGroup = answerLine.sub_answers.reduce((acc, item) => {
    const group = item.group_index
    if (!acc[group]) {
      acc[group] = []
    }
    acc[group].push(item)
    return acc
  }, [])

  return answersByGroup.map((answerGroup, index) => (
    <>
      <p>
        {answerLine.question.payload.separator_text} {index + 1}
      </p>
      <ol className="list-inside list-sub_index-decimal-bold">
        {answerGroup.map((childAnswerLine, key) => {
          return (
            <div className={clsx('pl-6', subChildrenClassName)} key={key}>
              <QuestionComponentMounter
                answer={childAnswerLine.response}
                question={childAnswerLine.question}
                dispatch={dispatch}
                kind={childAnswerLine.question.kind}
              />
            </div>
          )
        })}
      </ol>
    </>
  ))
}

AnswerLinesChildrenGroup.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  dispatch: PropTypes.string,
  subChildrenClassName: PropTypes.string
}
